export const SOJI_USER = 'SOJI_USER';
